/**
 * Regex de validation d'un uuid v4 (case insensitive)
 */
// eslint-disable-next-line prefer-regex-literals
const uuidV4RegEx = new RegExp(
  /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i
);

export default uuidV4RegEx;
